// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2Amah","buttons":"RemoveExpirationActionButtons_buttons__2Jlt6"};